import { useContext } from "react";
import LoginContext from "../context/LoginProvider";

function useLoginContext() {
    return useContext(LoginContext);
}

export { useLoginContext };